import CustomFields from '../modules/CustomFields'
import Forms from '../modules/Forms'
import Positions from '../modules/Positions'

/**
 * Add modules here.
 */

const modules = [CustomFields, Forms, Positions]
export default modules



// WEBPACK FOOTER //
// ./src/config/modules.js